import classNames from 'classnames';
import hoistNonReactStatistics from 'hoist-non-react-statics';
import React from 'react';
import { CardSC, clsPrefix } from './card.styled';
import { TCardSize, TCardVariant } from './card.types';
import CardHeader from './components/card-header';

interface CardProps
  extends Omit<
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    'ref'
  > {
  size?: TCardSize;
  variant?: TCardVariant;
}

const Card = (props: CardProps, ref?: React.Ref<HTMLDivElement>) => {
  const { children, style, size = 'small', variant = 'elevated', className, ...rest } = props;

  return (
    <CardSC
      {...rest}
      ref={ref}
      className={classNames(
        clsPrefix,
        className,
        `${clsPrefix}-${size}`,
        `${clsPrefix}-${variant}`,
      )}
      style={style}
    >
      {children}
    </CardSC>
  );
};

Card.Header = CardHeader;

export default hoistNonReactStatistics(React.forwardRef(Card), Card);
